export const padZeroAfterInterger = (num, places) => {
  const zero = places - num.toString().length + 1;
  return num + Array(+(zero > 0 && zero)).join('0');
};

export const makePositiveAmount = (num, withSymbol) => {
  if (withSymbol) {
    const amtvalue = num * 1;
    const amountValue = amtvalue < 0 ? amtvalue * -1 : amtvalue;
    return amountValue.toString();
  }
  return num;
};

export const formatWithSymbolNumber = (num, formatedValue) => {
  const amtvalue = num * 1;
  if (amtvalue < 0) {
    return <span className="negative-amount">{`(${formatedValue})`}</span>;
  }
  return formatedValue;
};

export const currencyFormat = (numb, locale, decimalPlaces, withSymbol) => {
  let lang;
  let currencyType;
  const num = numb !== undefined ? Number(numb) : 0;
  const currencySymbol = '$';
  const currencySymbolF = '€';
  let decimalSymbol;
  if (locale === 'en') {
    lang = 'en-US';
    currencyType = 'USD';
    decimalSymbol = '.';
  } else {
    lang = 'fr-FR';
    currencyType = 'EUR';
    decimalSymbol = ',';
  }
  const number = makePositiveAmount(num, withSymbol);
  const formatter = new Intl.NumberFormat(lang, {
    style: 'currency',
    currency: currencyType,
    minimumFractionDigits: decimalPlaces,
  });
  let data;
  const spChars = /[.]+/;
  if (spChars.test(number)) {
    const splitString = number.toString().split('.');
    data = formatter.format(splitString[0]);
    const numZeroPad = padZeroAfterInterger(splitString[1], decimalPlaces);
    const result = data.substring(0, data.lastIndexOf(decimalSymbol) + 1);
    data = result.concat('', numZeroPad);
    if (locale === 'fr') {
      data = data.concat(' ', currencySymbolF);
    }
  } else {
    data = formatter.format(number);
  }
  if (withSymbol) {
    const formatedValue = data.replace('€', '$');
    return formatWithSymbolNumber(num, formatedValue);
  }
  /* Symbol remover $, € */
  data = data.replace(currencySymbolF, '').trim();
  return data.replace(currencySymbol, '');
};
const caseNoTwo = 2;
export const renderCurrencyWithSymbol = (value, locale, decimalPlaces = caseNoTwo) => {
  // Return the same value if it's null or undefined
  if (value === null || value === undefined) {
    return value;
  }
  let amount = value;
  let amountString = 0;
  let isNegative = 0;
  if (amount < 0) {
    isNegative = 1;
    amount *= -1;
  }
  const formattedString = currencyFormat(Number(amount)?.toFixed(decimalPlaces), locale, decimalPlaces);
  if (locale === 'en') {
    amountString = `$${formattedString}`;
  } else {
    amountString = `${formattedString}$`;
  }
  if (isNegative) {
    amountString = `(${amountString})`;
    return <span className="negative-amount">{`${amountString}`}</span>;
  }

  return <>{amountString}</>;
};
